export const getIds = (debits) => {
  let idsDebits = []

  debits.forEach(item => {
    idsDebits.push(item.IdDebito)
  })

  return idsDebits
}
